import React from "react";
import { Form } from "components";

const cashbackImportStatuses = [
  { label: "Importado", value: "imported" },
  { label: "Contabilizado", value: "accounted" },
];

export function Filters({ filters, onChange, onClean }) {
  return (
    <Form>
      <div className="row">
        <Form.Field className="col-md-4">
          <Form.Label>Profissional</Form.Label>
          <Form.Input
            placeholder="123.123.123-12"
            value={filters.cpf}
            onChange={(event) => onChange("cpf", event.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Label>Situação</Form.Label>
          <Form.Select
            placeholder="Todas"
            options={cashbackImportStatuses}
            value={filters.status}
            onChange={(value) => onChange("status", value)}
            isClearable
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Label>Assessor</Form.Label>
          <Form.Input
            value={filters.accessorName}
            onChange={(event) => onChange("accessorName", event.target.value)}
          />
        </Form.Field>
      </div>

      <div className="row">
        <Form.Field className="col-md-3">
          <Form.Label>Período, de</Form.Label>
          {/* <Form.Icon name="calendar" /> */}
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.start_at}
            onChange={(value) => onChange("start_at", value)}
            minDate={new Date(2023, 0, 1)}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Período, até</Form.Label>
          {/* <Form.Icon name="calendar" /> */}
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.end_at}
            onChange={(value) => onChange("end_at", value)}
            minDate={filters.start_at}
            maxDate={new Date()}
            disabled={!filters.start_at}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Mês de referência</Form.Label>
          <Form.DatePicker
            showMonthYearPicker
            dateFormat="MM/yyyy"
            selected={filters.reference_date}
            onChange={(value) => onChange("reference_date", value)}
            minDate={new Date(2023, 0, 1)}
            maxDate={new Date()}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar filtros
          </Form.Button>
        </Form.Field>
      </div>
    </Form>
  );
}
